import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import {map, catchError} from 'rxjs/operators';
import {NeoGlobalService} from 'ng-neo';
import {NeoRest} from './neo-rest.sercive.model';
import {NeoStorageService} from "ng-neo/index";
import {NeoJWTService} from "../neo-jwt/neo-jwt";

/**
 * Se encarca de hacer las acciones contra la API
 * */
@Injectable()
export class NeoRestService implements NeoRest {

    constructor(
        private _http: HttpClient,
        private _gs: NeoGlobalService,
        private _neoStorage: NeoStorageService,
        private _jwt: NeoJWTService
    ) {
    }

    /**
     * Cabeceras
     *
     * @returns {HttpHeaders}
     */
    private getHeaders(): HttpHeaders {
        let headersConfig = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        };

        if (this._neoStorage.getFromLocalStorage('token')) {
            headersConfig['Authorization'] = 'Bearer ' + this._jwt.getToken().getToken();
        }

        return new HttpHeaders(headersConfig);
    }


    /**
     * Handler de error
     *
     * @returns {any}
     * @param res
     */
    private formatErrors(res: Response) {
        let error: any = res || res.body || {};
        if (error.error) {
            const msgObj = error.error;
            this._gs.set('alerts', {
                type: 'danger',
                msg: `${msgObj.Description}`
            });
        }

        if (error.status && error.status === 401) {
            this._gs.set('isLogin', false);
        }

        return Observable.throwError(error);
    }

    /**
     * Notifica cuando hay una nueva version
     *
     * @param {Response} res
     * @return {Response}
     */
    private checkVersion(res: Response) {
        if (this._gs.get("lastupdate") < res.headers.get("x-last-update")) {
            this._gs.set('newVersion', true);
        }

        return res.body;
    }

    /**
     * Envia una petición post con formato raw
     *
     * @param path
     * @param body
     * */
    postRaw(path: string, body: Object = {}): Observable<any> {
        return this._http.post(`${environment.api_url}${path}`, body, {observe: 'response', headers: this.getHeaders()})
            .pipe(
                catchError(this.formatErrors.bind(this)),
                map(this.checkVersion.bind(this)),
                map((res: Response) => {
                    // Refrescamos el tiempo
                    this._gs.set('timeover', (new Date()).getTime());

                    return res;
                })
            );
    }

    /**
     * Envia una petición post con formato raw
     *
     * @param path
     * @param body
     * */
    putRaw(path: string, body: Object = {}): Observable<any> {
        return this._http.put(`${environment.api_url}${path}`, body, {observe: 'response', headers: this.getHeaders()})
            .pipe(
                catchError(this.formatErrors.bind(this)),
                map(this.checkVersion.bind(this)),
                map((res: Response) => {
                    // Refrescamos el tiempo
                    this._gs.set('timeover', (new Date()).getTime());

                    return res;
                })
            );
    }

    /**
     * Envia una petición post
     *
     * @param path
     * @param body
     * */
    post(path: string, body: HttpParams = new HttpParams()): Observable<any> {
        const headers = this.getHeaders();
        headers.set('Content-Type', 'application/x-www-form-urlencoded');

        return this._http.post(`${environment.api_url}${path}`, body, {observe: 'response', headers})
            .pipe(
                catchError(this.formatErrors.bind(this)),
                map(this.checkVersion.bind(this)),
                map((res: Response) => {
                    // Refrescamos el tiempo
                    this._gs.set('timeover', (new Date()).getTime());

                    return res;
                })
            );
    }

    /**
     * Envia una petición get
     *
     * @param path
     * @param params
     * */
    get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
        return this._http.get(`${environment.api_url}${path}`, {observe: 'response', headers: this.getHeaders(), params})
            .pipe(
                catchError(this.formatErrors.bind(this)),
                map(this.checkVersion.bind(this)),
                map((res: Response) => {
                    // Refrescamos el tiempo
                    this._gs.set('timeover', (new Date()).getTime());

                    return res;
                })
            );
    }

    /**
     * Envia una petición get
     *
     * @param path
     * @param params
     * */
    delete(path: string, params: HttpParams = new HttpParams()): Observable<any> {
        return this._http.delete(`${environment.api_url}${path}`, {observe: 'response', headers: this.getHeaders(), params})
            .pipe(
                catchError(this.formatErrors.bind(this)),
                map(this.checkVersion.bind(this)),
                map((res: Response) => {
                    // Refrescamos el tiempo
                    this._gs.set('timeover', (new Date()).getTime());

                    return res;
                })
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-rest/neo-rest.service.ts